import { render, staticRenderFns } from "./index.vue?vue&type=template&id=c5bb44ac&scoped=true&"
import script from "./index.js?vue&type=script&lang=js&"
export * from "./index.js?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=c5bb44ac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5bb44ac",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data2/workspace/sc-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c5bb44ac')) {
      api.createRecord('c5bb44ac', component.options)
    } else {
      api.reload('c5bb44ac', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=c5bb44ac&scoped=true&", function () {
      api.rerender('c5bb44ac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/comment/components/goods/index.vue"
export default component.exports